import { useEffect } from 'react';
import { HashRouter, Routes, Route, useLocation } from 'react-router-dom';
import smoothscroll from 'smoothscroll-polyfill';
import 'swiper/css/bundle';

import { Detail } from 'containers/detail';
import { Home } from 'containers/home';
import { Search } from 'containers/search';
import { SendData } from 'containers/send-data';
import { Share } from 'containers/share';
import { DataProvider } from 'context/data-context';
//import { AppContextProvider } from 'context/app-context';

smoothscroll.polyfill();

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

function App() {
  return (
    <DataProvider>
      <HashRouter>
        <ScrollToTop />
        <Routes>
          <Route path="detail/:id" element={<Detail />} />
          <Route path="search/:search" element={<Search />} />
          <Route path="send-data" element={<SendData />} />
          <Route path="share" element={<Share />} />
          <Route path="/" element={<Home />} />
          <Route
            path="*"
            element={
              <main style={{ padding: '1rem' }}>
                <p>There's nothing here!</p>
              </main>
            }
          />
        </Routes>
      </HashRouter>
    </DataProvider>
  );
}

export default App;
